import { render, staticRenderFns } from "./OrganizLayout.vue?vue&type=template&id=347227ea&scoped=true&"
import script from "./OrganizLayout.vue?vue&type=script&lang=js&"
export * from "./OrganizLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347227ea",
  null
  
)

export default component.exports